var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgWarning = function SvgWarning(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.418 3.124 2.545 14.998a1.25 1.25 0 0 0 1.082 1.876h13.746a1.25 1.25 0 0 0 1.082-1.876L11.582 3.124a1.25 1.25 0 0 0-2.164 0Z",
    fill: "#FFCE14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.418 3.124 2.545 14.998a1.25 1.25 0 0 0 1.082 1.876h13.746a1.25 1.25 0 0 0 1.082-1.876L11.582 3.124a1.25 1.25 0 0 0-2.164 0Z",
    fill: "#fff",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.418 3.124 2.545 14.998a1.25 1.25 0 0 0 1.082 1.876h13.746a1.25 1.25 0 0 0 1.082-1.876L11.582 3.124a1.25 1.25 0 0 0-2.164 0ZM10.5 7.5v3.75",
    stroke: "#FFCE14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.875Z",
    fill: "#FFCE14"
  })));
};
export default SvgWarning;